// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"FZ-z","subtitle":"GZ-z","wrapper":"HZ-z","leftArrow":"IZ-z","rightArrow":"JZ-z"};